export default __webpack_public_path__ + "static/youtube_icon-e737c4c29bc73c64825e592ffdcede27.png";